import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Merged into Agents. Kept as a redirect rather than deleted: `/settings/*` is
 * deep-linked across apps, docs and desktop menus, so a deleted route is a 404
 * where a redirect is a scroll.
 */
export const Route = createFileRoute("/settings/composer")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/agents",
      hash: "composer",
      replace: true,
    });
  },
});
